/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Starting_InfoInputs */



/**
* | output |
* | --- |
* | "Importing team project... please wait." |
*
* @param {Team_Project_Import_Starting_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_starting_info = /** @type {((inputs?: Team_Project_Import_Starting_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Starting_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation du projet d’équipe... veuillez patienter.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teamprojekt wird importiert... bitte warten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione del progetto di gruppo... attendere.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт командного проекта... пожалуйста, подождите.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importando proyecto de equipo... por favor espere.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在导入团队项目……请稍候。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チーム プロジェクトをインポートしています... お待ちください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम प्रोजेक्ट आयात किया जा रहा है... कृपया प्रतीक्षा करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importando projeto de equipe... aguarde.")
	return /** @type {LocalizedString} */ ("Importing team project... please wait.")
});